import { RouteObject, useParams } from "react-router-dom";

export const ORGANIZATION_ROUTES: RouteObject[] = [
  {
    path: ":organizationId",
    async lazy() {
      const { OrganizationProfile } = await import("./profile/OrganizationProfile");
      return {
        Component() {
          const { organizationId } = useParams<{ organizationId: string }>();
          return <OrganizationProfile organizationId={organizationId!} />;
        },
      };
    },
  },
  {
    path: ":organizationId/linked_organizations",
    async lazy() {
      const { LinkedOrganizations } = await import("./linkedOrg/LinkedOrganizations");
      return {
        Component() {
          const { organizationId } = useParams<{ organizationId: string }>();
          return <LinkedOrganizations organizationId={organizationId!} />;
        },
      };
    },
  },
  {
    path: ":organizationId/external_accounts",
    async lazy() {
      const { OrganizationExternalAccounts } = await import("./externalAccounts/ExternalAccounts");
      return {
        Component() {
          const { organizationId } = useParams<{ organizationId: string }>();
          return <OrganizationExternalAccounts organizationId={organizationId!} />;
        },
      };
    },
  },
  {
    path: ":organizationId/account/:accountId",
    async lazy() {
      const { ScheduledTransfers } = await import("./scheduledTransfers/ScheduledTransfers");
      return {
        Component() {
          const { organizationId, accountId } = useParams<{
            organizationId: string;
            accountId: string;
          }>();
          return <ScheduledTransfers organizationId={organizationId!} accountId={accountId!} />;
        },
      };
    },
  },
  {
    path: ":organizationId/bulk_payments",
    async lazy() {
      const { BulkPayments } = await import("./bulk_payments/BulkPayments");
      return {
        Component() {
          const { organizationId } = useParams<{ organizationId: string }>();
          return <BulkPayments organizationId={organizationId!} />;
        },
      };
    },
  },
  {
    path: ":organizationId/bulk_payments/:bulkPaymentId/:paymentId?",
    async lazy() {
      const { BulkPaymentDetail } = await import("./bulk_payments/BulkPaymentDetail");
      return {
        Component() {
          const { organizationId, bulkPaymentId, paymentId } = useParams<{
            organizationId: string;
            bulkPaymentId: string;
            paymentId?: string;
          }>();
          return (
            <BulkPaymentDetail
              organizationId={organizationId!}
              bulkPaymentId={bulkPaymentId!}
              paymentId={paymentId}
            />
          );
        },
      };
    },
  },
  {
    path: ":organizationId/users",
    async lazy() {
      const { OrganizationUsers } = await import("./orgUsers/OrganizationUsers");
      return {
        Component() {
          const { organizationId } = useParams<{ organizationId: string }>();
          return <OrganizationUsers organizationId={organizationId!} />;
        },
      };
    },
  },
  {
    path: ":organizationId/:type",
    async lazy() {
      const { OrganizationLimitContainer } = await import("./orgLimit/OrganizationLimit");
      return {
        Component() {
          const { type, organizationId } = useParams<{ type: string; organizationId: string }>();

          return (
            <OrganizationLimitContainer organizationId={organizationId!} type={type as string} />
          );
        },
      };
    },
  },
];
